export const baseHeaders = {
  "x-application-id": process.env.VUE_APP_X_APPLICATION_ID,
  "x-application-key": process.env.VUE_APP_X_APPLICATION_KEY,
  "x-channel-id": process.env.VUE_APP_X_CHANNEL_ID,
  "x-organization-slug": process.env.VUE_APP_X_ORGANIZATION_SLUG,
  "x-platform": process.env.VUE_APP_X_PLATFORM,
  "x-platform-version": process.env.VUE_APP_X_PLATFORM_VERSION,
  "x-app-version": process.env.VUE_APP_X_APP_VERSION,
  "Accept-language": process.env.VUE_APP_X_ACCEPT_LANGUAGE,
};

export const gwAppKey = process.env.VUE_APP_X_GW_APP_KEY;
